(function () {
var NOT = 'Ekki valið';

function init(root) {
if (!root || root.getAttribute('data-usm-ready')) return;
root.setAttribute('data-usm-ready', '1');

var state = { tegund: null, tegundId: null, litur: null, bordplata: null, faetur: null, framhlidar: [], inni: [] };
var field = (root.getAttribute('data-usm-field') || 'Valið þitt').toLowerCase();
var lastText = '';
var vara = null;
try { vara = new URLSearchParams(window.location.search).get('vara'); } catch (e) {}

function q(sel) { return root.querySelector(sel); }
function qa(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
function out(key, val) { var el = q('[data-usm-out=' + key + ']'); if (el) el.textContent = val || NOT; }
function dims() {
var d = {};
qa('[data-usm-dim]').forEach(function (i) { d[i.getAttribute('data-usm-dim')] = (i.value || '').trim(); });
return d;
}
function space(d) {
if (!d.breidd && !d.haed && !d.dypt) return '';
return (d.breidd || '?') + ' × ' + (d.haed || '?') + ' × ' + (d.dypt || '?') + ' cm';
}
function buildText() {
var d = dims();
var lines = [];
if (vara) lines.push('Vara: ' + vara);
if (state.tegund) lines.push('Tegund: ' + state.tegund);
if (state.litur) lines.push('Litur: ' + state.litur);
if (state.tegundId === 'bord' && state.bordplata) lines.push('Borðplata: ' + state.bordplata);
if (space(d)) lines.push('Rými (B × H × D): ' + space(d));
if (state.framhlidar.length) lines.push('Framhliðar og plötur: ' + state.framhlidar.join(', '));
if (state.inni.length) lines.push('Inni í einingunni: ' + state.inni.join(', '));
if (state.faetur) lines.push('Fætur eða hjól: ' + state.faetur);
return lines.join('\n');
}

function labelFor(el) {
var texts = [el.getAttribute('placeholder'), el.getAttribute('name'), el.getAttribute('aria-label')];
if (el.id) {
try {
var id = window.CSS && CSS.escape ? CSS.escape(el.id) : el.id;
var l = document.querySelector('label[for=' + id + ']');
if (l) texts.push(l.textContent);
} catch (e) {}
}
var p = el.parentElement;
for (var i = 0; i < 5 && p; i++) {
if (p.querySelectorAll('input, textarea, select').length > 1) break;
var lab = p.querySelector('label');
if (lab) { texts.push(lab.textContent); break; }
p = p.parentElement;
}
return texts.filter(Boolean).join(' ').toLowerCase();
}
function fillForm() {
var box = q('.globo-formbuilder');
if (!box) return;
var fields = box.querySelectorAll('textarea, input[type=text]');
for (var i = 0; i < fields.length; i++) {
if (labelFor(fields[i]).indexOf(field) === -1) continue;
var val = fields[i].tagName === 'TEXTAREA' ? lastText : lastText.split('\n').join(' · ');
if (fields[i].value !== val) {
var desc = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(fields[i]), 'value');
if (desc && desc.set) { desc.set.call(fields[i], val); } else { fields[i].value = val; }
fields[i].dispatchEvent(new Event('input', { bubbles: true }));
fields[i].dispatchEvent(new Event('change', { bubbles: true }));
}
return;
}
}

function update() {
var d = dims();
var isTable = state.tegundId === 'bord';
out('tegund', state.tegund);
out('litur', state.litur);
out('bordplata', state.bordplata);
out('rymi', space(d));
out('framhlidar', state.framhlidar.join(', '));
out('inni', state.inni.join(', '));
out('faetur', state.faetur);
var tops = q('[data-usm-tops]');
if (tops) tops.hidden = !isTable;
var row = q('[data-usm-row=bordplata]');
if (row) row.hidden = !isTable;
lastText = buildText();
var ta = q('[data-usm-summary-text]');
if (ta) ta.value = lastText;
fillForm();
}

root.addEventListener('click', function (e) {
var btn = e.target && e.target.closest ? e.target.closest('[data-usm-group]') : null;
if (!btn || !root.contains(btn)) return;
var group = btn.getAttribute('data-usm-group');
var value = btn.getAttribute('data-usm-value');
var multi = btn.hasAttribute('data-usm-multi');
if (multi) {
var list = state[group];
var idx = list.indexOf(value);
if (idx === -1) { list.push(value); } else { list.splice(idx, 1); }
} else {
var same = state[group] === value;
state[group] = same ? null : value;
if (group === 'tegund') state.tegundId = same ? null : btn.getAttribute('data-usm-id');
if (group === 'litur') {
if (same) { root.style.setProperty('--usm-colour', '#FFFFFF'); } else { root.style.setProperty('--usm-colour', btn.getAttribute('data-usm-hex')); }
}
}
qa('[data-usm-group=' + group + ']').forEach(function (b) {
var v = b.getAttribute('data-usm-value');
var on = multi ? state[group].indexOf(v) !== -1 : state[group] === v;
b.setAttribute('aria-pressed', on ? 'true' : 'false');
});
update();
});

qa('[data-usm-dim]').forEach(function (i) { i.addEventListener('input', update); });

var mail = q('[data-usm-mailto]');
if (mail) {
mail.addEventListener('click', function () {
var ta = q('[data-usm-summary-text]');
var body = ta ? ta.value : lastText;
mail.setAttribute('href', 'mailto:' + root.getAttribute('data-usm-email') + '?subject=' + encodeURIComponent('USM fyrirspurn') + '&body=' + encodeURIComponent(body + '\n\n'));
});
}

if (vara) {
var v = q('[data-usm-vara]');
var vn = q('[data-usm-vara-name]');
if (v && vn) { vn.textContent = vara; v.hidden = false; }
var vr = q('[data-usm-row=vara]');
if (vr) vr.hidden = false;
out('vara', vara);
}

var box = q('.globo-formbuilder');
if (box && 'MutationObserver' in window) {
new MutationObserver(function () { fillForm(); }).observe(box, { childList: true, subtree: true });
}

update();

/* Sýningarsalurinn jafn hár og efsti hlutinn í tölvu */
var hero = q('.UsmH__Hero');
var salur = q('.UsmH__Showroom');
var syncH = function () {
if (!hero || !salur) return;
if (window.innerWidth >= 760) { salur.style.minHeight = hero.offsetHeight + 'px'; } else { salur.style.minHeight = ''; }
};
syncH();
window.addEventListener('resize', syncH);
window.addEventListener('load', syncH);
try { if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncH); } catch (e) {}

var wrap = q('[data-usm-slides]');
if (wrap) {
var slides = Array.prototype.slice.call(wrap.querySelectorAll('[data-usm-slide]'));
var count = wrap.querySelector('[data-usm-count]');
var cur = 0;
var timer = null;
var reduce = false;
try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
var auto = root.getAttribute('data-usm-autoplay') === '1' && !reduce && slides.length > 1;
var wait = Math.max(3, parseInt(root.getAttribute('data-usm-interval'), 10) || 5) * 1000;
var show = function (n) {
if (!slides.length) return;
cur = (n % slides.length + slides.length) % slides.length;
slides.forEach(function (s, k) {
s.classList.toggle('is-active', k === cur);
s.setAttribute('aria-hidden', k === cur ? 'false' : 'true');
});
if (count) count.textContent = (cur + 1) + ' / ' + slides.length;
};
var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
var start = function () { stop(); if (auto && !document.hidden && document.body.contains(wrap)) timer = setInterval(function () { show(cur + 1); }, wait); };
var prev = wrap.querySelector('[data-usm-prev]');
var next = wrap.querySelector('[data-usm-next]');
if (prev) prev.addEventListener('click', function () { show(cur - 1); start(); });
if (next) next.addEventListener('click', function () { show(cur + 1); start(); });
document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });
if (slides.length < 2) { var bar = wrap.querySelector('.UsmH__Arrows'); if (bar) bar.hidden = true; }
show(0);
start();
}
}

function initAll(scope) {
Array.prototype.slice.call((scope || document).querySelectorAll('[data-usm-root]')).forEach(init);
}

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', function () { initAll(); });
} else {
initAll();
}
document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();